import { render, staticRenderFns } from "./list-skeleton.vue?vue&type=template&id=52533506&scoped=true"
import script from "./list-skeleton.vue?vue&type=script&lang=js"
export * from "./list-skeleton.vue?vue&type=script&lang=js"
import style0 from "./list-skeleton.vue?vue&type=style&index=0&id=52533506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52533506",
  null
  
)

export default component.exports